import { Inject, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';

@Injectable({ providedIn: 'root' })
export class GlobalService {
  public data: any = [];

  constructor(
    @Inject(LOCAL_STORAGE) private storage: StorageService,
    private toastr: ToastrService
  ) {}

  showSuccess(message: string) {
    this.toastr.success(message);
  }

  showError(message: string) {
    this.toastr.error(message);
  }

  setLocalStore(key: string, val: any): void {
    this.storage.set(key, val);
    this.data[key] = this.storage.get(key);
  }

  getLocalStore(key: string): any {
    this.data[key] = this.storage.get(key);
    return this.data[key];
  }
}
